<template>
  <!--  <perfect-scrollbar :options="optionsScrollbar">-->
  <div class="legend-price is-flex">
    <div class="btn">
      <button class="btn-drop" @click="visiblePrice">
        <div>
          Ценовые обозначения
        </div>
        <div class="arrow-down" :class="{ 'rotated': show }"></div>
      </button>
    </div>
    <transition name="slide">
      <ul v-if="show">
        <template v-for="(item, index) in legend">
          <li class="legend-price__item is-flex" v-bind:key="index"
              v-if="item.free_places > 0" @click="clickPrice(item.price)">
            <div class="legend-price__item__color" :style="`background-color: ${item.color};`"></div>
            <div class="legend-price__item__price is-size-7">{{ item.price }} руб.</div>
          </li>
        </template>
        <template>
          <li class="legend-price__item is-flex">
            <div class="legend-price__item__color">

              <svg height="19" width="100" xmlns="http://www.w3.org/2000/svg">
                <circle r="7" cx="8.5" cy="8.5" stroke="#ffffff" stroke-width="2" fill="red"/>
              </svg>
            </div>
            <div class="legend-price__item__price is-size-7">Места установки телекамер</div>
          </li>
        </template>
      </ul>
    </transition>
  </div>
  <!--  </perfect-scrollbar>-->
</template>

<script>
import {mapState} from "vuex";
// import {PerfectScrollbar} from 'vue2-perfect-scrollbar'

export default {
  name: "LegendPrice",
  components: {
    // PerfectScrollbar
  },
  data() {
    return {
      show: false,
      priceSelected: null,
      optionsScrollbar: {
        suppressScrollY: true,
        useBothWheelAxes: true
      },
    }
  },
  computed: {
    ...mapState({
      hallPlan: state => state.hallPlan,
      mobile: state => state.mobile,
    }),
    legend() {
      let legend = [];
      console.log(this.$route.params.section_id)
      if (this.hallPlan.length > 0 && this.$route.params.section_id) {
        let section = this.hallPlan.find(i => i.id === parseInt(this.$route.params.section_id));
        if (section && section.legendTariffs) {
          legend = section.legendTariffs;
        } else {
          legend = [];
          this.hallPlan.forEach((i) => {
            i.legendTariffs.forEach((z) => {
              if (!legend.find(elem => elem.price === z.price)) {
                legend.push(z)
              }
            })
          })
        }
      } else if (this.hallPlan.length > 0) {
        this.hallPlan.forEach((i) => {
          i.legendTariffs.forEach((z) => {
            if (!legend.find(elem => elem.price === z.price)) {
              legend.push(z)
            }
          })
        })
      }
      return legend.sort(function (a, b) {
        if (a.price > b.price) {
          return 1;
        }
        if (a.price < b.price) {
          return -1;
        }
        return 0;
      });
    },
  },
  methods: {
    visiblePrice() {
      this.show = !this.show;
    },
    clickPrice(price) {
      if (this.mobile) {
        return
      }
      if (this.priceSelected === price) {
        this.priceSelected = null
        this.$store.commit('setLegendSelected', false);
        this.$events.$emit('legendSelectedEvent', 0);
      } else {
        this.priceSelected = price
        this.$store.commit('setLegendSelected', true);
        this.$events.$emit('legendSelectedEvent', this.priceSelected);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

}

.btn-drop {
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 2px solid #1c93e6;
  border-radius: 15px;
  min-width: 160px;
  cursor: pointer;
  outline: none;
  padding: 5px 10px;
  color: #fff;
}

.btn-drop:hover {
  background-color: #1c93e6;
}

.arrow-down {
  display: inline-block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
  transition: transform 0.3s ease;
}

.arrow-down.rotated {
  transform: rotate(180deg);
}

.slide-enter-active, .slide-leave-active {
  transition: max-height 0.3s ease-in-out;
}

.slide-enter, .slide-leave-to {
  max-height: 0;
  overflow: hidden;
}

.slide-enter-to, .slide-leave {
  max-height: 500px;
}

</style>
